import { Route } from '@angular/router';
import { authGuard } from './auth/guards/auth.guard';
import { campaignManageGuard } from './auth/guards/campaign-manage.guard';
import { globalAdminGuard } from './auth/guards/global-admin.guard';
import { tenantAdminGuard } from './auth/guards/tenant-admin.guard';

export const appRoutes: Route[] = [
  { path: 'login', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./auth/components/login/login.component').then(
            (m) => m.LoginComponent,
          ),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./auth/components/register/register.component').then(
            (m) => m.RegisterComponent,
          ),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
  {
    path: 'campaigns/public/:identifier',
    loadComponent: () =>
      import('./campaign/public-campaign/public-campaign.component').then(
        (m) => m.PublicCampaignComponent,
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layouts/authenticated-layout/authenticated-layout.component').then(
        (m) => m.AuthenticatedLayoutComponent,
      ),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./profile/profile.component').then((m) => m.ProfileComponent),
      },
      {
        path: 'campaigns',
        canActivate: [campaignManageGuard],
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./campaign/campaign-management-page.component').then(
                (m) => m.CampaignManagementPageComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./campaign/campaign-detail-page/campaign-detail-page.component').then(
                (m) => m.CampaignDetailPageComponent,
              ),
            children: [
              {
                path: 'questions',
                loadComponent: () =>
                  import('./campaign/questions/campaign-questions.component').then(
                    (m) => m.CampaignQuestionsComponent,
                  ),
              },
              {
                path: 'submissions',
                loadComponent: () =>
                  import('./campaign/submissions/campaign-submissions.component').then(
                    (m) => m.CampaignSubmissionsComponent,
                  ),
              },
              {
                path: 'analytics',
                loadComponent: () =>
                  import('./campaign/analytics/campaign-analytics.component').then(
                    (m) => m.CampaignAnalyticsComponent,
                  ),
              },
              { path: '', redirectTo: 'questions', pathMatch: 'full' },
            ],
          },
        ],
      },
      {
        path: 'organizations',
        canActivate: [globalAdminGuard],
        loadComponent: () =>
          import('./organizations/organizations-page.component').then(
            (m) => m.OrganizationsPageComponent,
          ),
      },
      {
        path: 'roles',
        canActivate: [globalAdminGuard],
        loadComponent: () =>
          import('./roles/roles-page.component').then(
            (m) => m.RolesPageComponent,
          ),
      },
      {
        path: 'users',
        canActivate: [tenantAdminGuard],
        loadComponent: () =>
          import('./users').then((m) => m.UsersPageComponent),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '' },
];
